// services/correspondenciaConfigService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'correspondencia-config/';

export interface PrecioPlanServicio {
    id: number;
    servicio: number;
    servicio_nombre: string;
    plan_nombre: string;
    unidad: string;
    dias: number;
    horas: number;
    precio_inicial: string;
    precio_posterior: string | null;
    duracion_inicial: number | null;
    estado: boolean;
    usar_contador: boolean;
    fecha_creacion: string;
}

export interface PrecioPlanServicioInfo {
    id: number;
    nombre_servicio: string;
    plan_nombre: string;
    precio_inicial: number;
}

export interface CorrespondenciaConfig {
    id: number;
    precio_plan_servicio: number;
    precio_plan_servicio_info: PrecioPlanServicioInfo | null;
    descripcion: string | null;
    estado: boolean;
    fecha_creacion: string;
}

export const fetchCorrespondenciaConfigs = async (): Promise<CorrespondenciaConfig[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const fetchCorrespondenciaConfigById = async (id: number): Promise<CorrespondenciaConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

export const createCorrespondenciaConfig = async (data: {
    precio_plan_servicio: number;
    descripcion?: string;
    estado?: boolean;
}): Promise<CorrespondenciaConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

export const updateCorrespondenciaConfig = async (
    id: number,
    data: {
        precio_plan_servicio?: number;
        descripcion?: string;
        estado?: boolean;
    }
): Promise<CorrespondenciaConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch(`${API_URL}${id}/`, data);
        return response.data;
    });
};

export const deleteCorrespondenciaConfig = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};

// Función para activar/desactivar configuración
export const toggleCorrespondenciaConfigStatus = async (
    id: number,
    estado: boolean
): Promise<CorrespondenciaConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch(`${API_URL}${id}/`, { estado });
        return response.data;
    });
};

// Función para obtener PrecioPlanServicio disponibles para correspondencia
export const fetchPrecioPlanServicioForCorrespondencia = async (): Promise<PrecioPlanServicio[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get('precio-plan-servicio/');
        return response.data;
    });
};